import { FC } from 'react';
import useGetMetadataQuery from '../../../reactQuery/hooks/useGetMetadata';

const MetadataLayer: FC = () => {
	useGetMetadataQuery();
	return <div />;
};

export default MetadataLayer;
